import { useEffect, useState, useContext } from "react";
import { Route } from "react-router-dom";

import { AppContexts } from "../../providers/";

import AppLayout from "./app-layout";
import Header from "../standard/header";
import Sidebar from "../standard/sidebar";
import Loading from "../common/Loading";

import ViewportBox from "../ui-kit/components/viewport-box";
import LineClamp from "../ui-kit/components/line-clamp";
import AnnouncementModal from "../common/AnnouncementModal";

const tone = new Audio(
  "https://s3.us-east-2.amazonaws.com/uploads.ruebarue.com/notification-tone.mp3",
);

const AppLoader = () => {
  const { user, inbox, inboxes, refresh, loading } = useContext(
    AppContexts.AuthContext,
  );
  const { notification, getNotification, setNotification } = useContext(
    AppContexts.UtilContext,
  );

  const [socketInboxes, setSocketInboxes] = useState([]);

  useEffect(() => {
    refresh();
  }, []);

  const addSocketListeners = (conn) => {
    conn.addEventListener("open", () => {
      window.dispatchEvent(new Event("websocket-connect"));

      conn.addEventListener("close", () => {
        setSocketInboxes([]);
        addSocketListeners(
          new WebSocket(
            "wss://c8cp9nllvl.execute-api.us-east-2.amazonaws.com/prod/",
          ),
        );
      });

      conn.addEventListener("message", (e) => {
        if (e.data === "") return;

        const message = JSON.parse(e.data);
        // console.log("New Websocket Incoming", message);

        if (notification?.message_id !== message.message_id) {
          setNotification(message);
        }
      });

      const joinedInboxes = inbox?.inboxes || [];
      if (joinedInboxes.length > 0) {
        joinedInboxes.forEach((ibx) => {
          if (socketInboxes.includes(ibx.id)) return;

          conn.send(
            JSON.stringify({
              service: "notifications",
              action: "join",
              data: {
                room: ibx.id,
              },
            }),
          );

          setSocketInboxes((prev) => [...prev, ibx.id]);
        });
      }
    });
  };

  useEffect(() => {
    if (!inbox) return;

    addSocketListeners(
      new WebSocket(
        "wss://c8cp9nllvl.execute-api.us-east-2.amazonaws.com/prod/",
      ),
    );
  }, [inbox]);

  useEffect(() => {
    if (!!window.socket && !!inbox) {
      window.socket.emit("join", { inbox_id: inbox.inbox_id });
      window.socket.on("disconnect", () => {
        console.log("reconnecting");
        window.socket.emit("join", { inbox_id: inbox.inbox_id });
      });

      window.socket.on("incoming", (resp) => {
        getNotification(resp);
      });
    } else {
      window.addEventListener("socket-connect", () => {
        if (!!inbox) {
          window.socket.emit("join", { inbox_id: inbox.inbox_id });
          window.socket.on("disconnect", () => {
            window.socket.emit("join", { inbox_id: inbox.inbox_id });
          });

          window.socket.on("incoming", (resp) => {
            getNotification(resp);
          });
        }
      });
    }
  }, [inbox]);

  useEffect(() => {
    if (!!notification && window.Notification?.permission === "granted") {
      const silentTypes = ["automated", "user", "recipient"];
      if (!silentTypes.includes(notification.message_type)) {
        new window.Notification(notification.headline, {
          body: notification.message_content,
          icon: "/images/logo.png",
        });

        tone.play();
      }
    }
  }, [notification]);

  useEffect(() => {
    window.UIkit.component("ViewportBox", ViewportBox);
    window.UIkit.component("LineClamp", LineClamp);
  }, []);

  return (
    <div className="rbr-app-shell">
      <AnnouncementModal />
      <Sidebar />

      <div className="rbr-app-main">
        <Header />
        <Route
          path="/"
          render={(props) => (!loading ? <AppLayout {...props} /> : <Loading />)}
        />
      </div>
    </div>
  );
};

export default AppLoader;